import React from 'react';
import { Button } from '@/components/ui/button';
import { Shuffle, Plus } from 'lucide-react';

const TRANSITIONS = [
  { type: 'crossfade', label: 'Crossfade / Dissolve' },
  { type: 'fade_through_black', label: 'Fade Through Black' },
  { type: 'wipe', label: 'Wipe' },
  { type: 'slide', label: 'Slide' },
  { type: 'zoom', label: 'Zoom' },
];

/**
 * Browsable Transitions catalog for the Main Editor sidebar (works with
 * zero media loaded). "Apply" performs a REAL set of `transition_in` on
 * the selected item via `updateMasterItem` — not a fabricated preview —
 * it is just disabled, with an explanation, until a video clip is
 * selected on the timeline.
 */
export function EditorTransitionsCatalogPanel({ selectedItem, onApplyTransition }) {
  const canApply = selectedItem && selectedItem.item_type === 'video';
  return (
    <div className="space-y-2" data-testid="transitions-catalog-panel">
      <p className="text-xs text-[#555E6E] uppercase tracking-wide flex items-center gap-1.5"><Shuffle className="h-3 w-3" />Browse Transitions</p>
      {!canApply && (
        <p className="text-[11px] text-amber-400/80" data-testid="transitions-catalog-hint">
          Select a video clip on the timeline to apply a transition to its start.
        </p>
      )}
      {TRANSITIONS.map((tr) => (
        <div key={tr.type} className="p-2.5 rounded-lg bg-white/[0.03] border border-white/10 flex items-center justify-between gap-2" data-testid={`transitions-catalog-item-${tr.type}`}>
          <p className="text-xs text-white font-medium">{tr.label}</p>
          <Button
            size="sm" variant="outline" className="h-7 text-[10px] border-white/10 shrink-0"
            disabled={!canApply}
            onClick={() => onApplyTransition(tr.type)}
            data-testid={`transitions-catalog-apply-${tr.type}`}
          >
            <Plus className="h-3 w-3 mr-1" />Apply
          </Button>
        </div>
      ))}
      <p className="text-[10px] text-[#555E6E] pt-1">Adjust duration and direction for an applied transition in Properties once its clip is selected.</p>
    </div>
  );
}
